import { TDtoCuisineEntry } from "./__types__/TDtoCuisineEntry";
import { TParseDto } from "../__types__/dto";

export const DtoCuisineParser: TParseDto<TDtoCuisineEntry> = (
  data: any
): TDtoCuisineEntry => ({
  id: data.id,
  name: data.name ?? "",
  sort: data.sort,
  status: Boolean(data.status),
});
